import axios from 'axios';
import Pusher from 'pusher-js';
import PusherService from '@/app/services/PusherService';
import { axiosXSRFTokenInterceptor } from '@/utils/csrfToken';

window.axios = axios;
window.Pusher = Pusher;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Inertia.js가 사용하는 axios 인스턴스에 XSRF-TOKEN 확인 인터셉터 추가
window.axios.interceptors.request.use(axiosXSRFTokenInterceptor, (error) => {
    return Promise.reject(error);
});

// 개발 환경에서만 XDEBUG 세션 파라미터 추가
if (import.meta.env.MODE == 'development') {
    axios.interceptors.request.use((config) => {
        // URL에 파라미터가 있는지 확인
        const separator = config.url?.includes('?') ? '&' : '?';

        // URL에 XDEBUG_SESSION_START 파라미터 추가
        config.url = `${config.url}${separator}XDEBUG_SESSION_START=PHPSTORM`;

        // Socket ID가 있는 경우 헤더에 추가
        const socketId = PusherService.getInstance().echo.socketId();
        if (socketId) {
            config.headers['X-Socket-ID'] = socketId;
        }

        return config;
    });
}
